export const REALTIME_EVENT = {
  CONVERSATION_MESSAGE_CREATED: "conversation.message.created",
  CONVERSATION_UNREAD_UPDATED: "conversation.unread.updated",
  NOTIFICATION_CREATED: "notification.created",
  NOTIFICATION_UNREAD_COUNT: "notification.unread_count",
  FEED_POST_CREATED: "feed.post.created",
  FEED_POST_UPDATED: "feed.post.updated",
  FEED_POST_DELETED: "feed.post.deleted",
  FEED_POST_LIKED: "feed.post.liked",
  FEED_POST_UNLIKED: "feed.post.unliked",
  FEED_POST_COMMENTED: "feed.post.commented",
  STORY_SLIDE_CREATED: "story.slide.created",
  STORY_RING_UPDATED: "story.ring.updated",
} as const;

export type RealtimeEventPayload = {
  v?: number;
  type?: string;
  entityId?: string;
  actorId?: string;
  actorRole?: string;
  timestamp?: number;
  payload?: Record<string, unknown>;
};

export type RealtimeListener = (event: RealtimeEventPayload) => void;

export type RealtimeSubscription = {
  destination: string;
  listener: RealtimeListener;
};

const DOC_REQUEST_MESSAGE_TYPES = new Set([
  "REQUESTED_FILES",
  "FILE_UPLOAD",
  "DOC_REQUEST",
  "DOCUMENT_REQUEST",
]);

export function isDocRequestRelatedEvent(event: RealtimeEventPayload): boolean {
  const messageType = String(event.payload?.messageType || "").toUpperCase();
  return DOC_REQUEST_MESSAGE_TYPES.has(messageType);
}

export const SOCIAL_FEED_EVENT_TYPES = new Set<string>([
  REALTIME_EVENT.FEED_POST_CREATED,
  REALTIME_EVENT.FEED_POST_UPDATED,
  REALTIME_EVENT.FEED_POST_DELETED,
  REALTIME_EVENT.FEED_POST_LIKED,
  REALTIME_EVENT.FEED_POST_UNLIKED,
  REALTIME_EVENT.FEED_POST_COMMENTED,
  REALTIME_EVENT.STORY_RING_UPDATED,
  REALTIME_EVENT.STORY_SLIDE_CREATED,
]);

export const SOCIAL_NOTIFICATION_EVENT_TYPES = new Set<string>([
  REALTIME_EVENT.FEED_POST_LIKED,
  REALTIME_EVENT.FEED_POST_COMMENTED,
  REALTIME_EVENT.NOTIFICATION_CREATED,
]);

export const HOSPITAL_CONVERSATION_EVENT_TYPES = new Set<string>([
  REALTIME_EVENT.CONVERSATION_MESSAGE_CREATED,
  REALTIME_EVENT.CONVERSATION_UNREAD_UPDATED,
]);
